import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';

@Injectable()
export class EditorGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

canActivate(
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean> | Promise<boolean> | boolean {
  return this.auth.user
    .take(1)
    .map((user) => {
      console.log('user-=='+ user.uid);
      console.log('uid=='+ next.params.uid);
      return (user.roles.superAdmin === true || user.roles.admin === true ) ? true : (user.uid === next.params.uid) ;
    })
    .do((loggedIn) => {
      if (!loggedIn) {
        console.log('only editors allowed');
        this.router.navigate(['/login']);
      }
    });
}
}



// WEBPACK FOOTER //
// ./src/app/core/editor.guard.ts